// extracted by mini-css-extract-plugin
export var background = "Z_x";
export var backgroundContainer = "Z_d8";
export var buttons = "Z_bC";
export var container = "Z_b";
export var middleWave = "Z_b4";
export var section = "Z_j";
export var text = "Z_bw";
export var textContainer = "Z_b6";
export var title = "Z_g";